/*
  Visualizador das fotos enviadas nas avaliações.

  Abre a foto em tamanho grande sobre um fundo escurecido, com navegação quando
  a mesma avaliação traz mais de uma imagem. Não depende de nada externo: usa só
  o que o navegador já oferece.

  Duas coisas guiam o desenho deste arquivo:
  - o clique é tratado por delegação no documento, porque parte das fotos entra
    na página depois, pelo botão de carregar mais avaliações;
  - o arquivo pode ser incluído mais de uma vez na mesma página, então a trava
    logo abaixo garante uma única inicialização e um único overlay.
*/
(function () {
  'use strict';

  if (window.dlReviewLightboxReady) return;
  window.dlReviewLightboxReady = true;

  var TRIGGER = '[data-dl-lightbox]';
  var GALLERY = '[data-dl-gallery]';
  // aceita só cor simples, para nunca injetar valor arbitrário no estilo
  var COR_OK = /^(#[0-9a-fA-F]{3,8}|rgba?\([0-9\s.,%\/]+\))$/;

  var raiz = null;
  var foto = null;
  var contador = null;
  var btFechar = null;
  var btAnterior = null;
  var btProxima = null;

  var fotos = [];
  var atual = 0;
  var origem = null;
  var travaScroll = null;

  /* ---------------------------------------------------------------- estilo */

  function estilo() {
    return [
      '.dl-lb{position:fixed;top:0;right:0;bottom:0;left:0;z-index:100000;',
      'display:flex;align-items:center;justify-content:center;',
      'padding:clamp(14px,4vw,48px);box-sizing:border-box;--dl-lb-cor:#3E1D28;',
      'background:rgba(0,0,0,.82);cursor:zoom-out}',
      '.dl-lb[hidden]{display:none}',
      '.dl-lb *{box-sizing:border-box}',
      '.dl-lb__palco{position:relative;display:flex;flex-direction:column;',
      'align-items:center;gap:14px;max-width:100%;max-height:100%;cursor:default}',
      '.dl-lb__img{display:block;max-width:92vw;max-width:min(92vw,1100px);',
      'max-height:78vh;width:auto;height:auto;object-fit:contain;border-radius:3px;',
      'background:#fff;box-shadow:0 14px 46px rgba(0,0,0,.5);',
      'opacity:1;transition:opacity .18s ease}',
      '.dl-lb.is-loading .dl-lb__img{opacity:0}',
      '.dl-lb__contador{margin:0;font-family:inherit;font-size:12px;font-weight:600;',
      'line-height:1;letter-spacing:.12em;color:#fff;background:rgba(0,0,0,.55);',
      'border:1px solid var(--dl-lb-cor);border-radius:99px;padding:7px 14px}',
      '.dl-lb__bt{position:absolute;display:flex;align-items:center;',
      'justify-content:center;width:44px;height:44px;padding:0;margin:0;border:0;',
      'border-radius:50%;background:rgba(255,255,255,.94);color:#1c1d1d;',
      'cursor:pointer;-webkit-appearance:none;appearance:none;',
      'box-shadow:0 2px 10px rgba(0,0,0,.35);transition:background .15s ease,color .15s ease}',
      '.dl-lb__bt:hover{background:var(--dl-lb-cor);color:#fff}',
      '.dl-lb__bt:focus-visible{outline:2px solid #fff;outline-offset:3px}',
      '.dl-lb__bt svg{width:18px;height:18px;display:block;fill:none;stroke:currentColor;',
      'stroke-width:2;stroke-linecap:round;stroke-linejoin:round;pointer-events:none}',
      '.dl-lb__bt[hidden]{display:none}',
      '.dl-lb__contador[hidden]{display:none}',
      '.dl-lb__bt--fechar{top:clamp(10px,3vw,28px);right:clamp(10px,3vw,28px)}',
      '.dl-lb__bt--ant{left:clamp(8px,2.5vw,28px);top:50%;transform:translateY(-50%)}',
      '.dl-lb__bt--prox{right:clamp(8px,2.5vw,28px);top:50%;transform:translateY(-50%)}',
      '@media (max-width:749px){',
      '.dl-lb__img{max-width:94vw;max-height:70vh}',
      '.dl-lb__bt{width:38px;height:38px}',
      '.dl-lb__bt svg{width:16px;height:16px}}'
    ].join('');
  }

  /* ------------------------------------------------------------- montagem */

  function icone(d) {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + d + '"/></svg>';
  }

  function montar() {
    if (raiz) return raiz;

    var folha = document.createElement('style');
    folha.setAttribute('data-dl-lightbox-style', '');
    folha.textContent = estilo();
    (document.head || document.documentElement).appendChild(folha);

    raiz = document.createElement('div');
    raiz.className = 'dl-lb';
    raiz.setAttribute('role', 'dialog');
    raiz.setAttribute('aria-modal', 'true');
    raiz.setAttribute('aria-label', 'Review photo');
    raiz.hidden = true;
    // o escurecido fica no próprio overlay: o tema esconde div vazia
    // (regra div:empty), então um elemento só para o fundo nunca apareceria
    raiz.innerHTML =
      '<div class="dl-lb__palco">' +
        '<img class="dl-lb__img" alt="">' +
        '<p class="dl-lb__contador" aria-live="polite"></p>' +
      '</div>' +
      '<button type="button" class="dl-lb__bt dl-lb__bt--fechar" aria-label="Close">' +
        icone('M6 6l12 12M18 6L6 18') +
      '</button>' +
      '<button type="button" class="dl-lb__bt dl-lb__bt--ant" aria-label="Previous photo">' +
        icone('M15 5l-7 7 7 7') +
      '</button>' +
      '<button type="button" class="dl-lb__bt dl-lb__bt--prox" aria-label="Next photo">' +
        icone('M9 5l7 7-7 7') +
      '</button>';

    document.body.appendChild(raiz);

    foto = raiz.querySelector('.dl-lb__img');
    contador = raiz.querySelector('.dl-lb__contador');
    btFechar = raiz.querySelector('.dl-lb__bt--fechar');
    btAnterior = raiz.querySelector('.dl-lb__bt--ant');
    btProxima = raiz.querySelector('.dl-lb__bt--prox');

    foto.addEventListener('load', assentar);
    foto.addEventListener('error', assentar);

    btFechar.addEventListener('click', fechar);
    btAnterior.addEventListener('click', function () { mostrar(atual - 1); });
    btProxima.addEventListener('click', function () { mostrar(atual + 1); });

    raiz.addEventListener('click', function (ev) {
      var alvo = ev.target && ev.target.nodeType === 1 ? ev.target : null;
      if (!alvo) return;
      if (alvo.closest('.dl-lb__bt')) return;
      if (alvo.closest('.dl-lb__img')) return;
      fechar();
    });

    return raiz;
  }

  function assentar() {
    if (raiz) raiz.classList.remove('is-loading');
  }

  /* --------------------------------------------------------------- dados */

  function endereco(gatilho) {
    if (gatilho.getAttribute('data-dl-full')) return gatilho.getAttribute('data-dl-full');
    var img = gatilho.tagName === 'IMG' ? gatilho : gatilho.querySelector('img');
    if (!img) return '';
    return img.currentSrc || img.src || '';
  }

  function descricao(gatilho) {
    var img = gatilho.tagName === 'IMG' ? gatilho : gatilho.querySelector('img');
    return img ? img.getAttribute('alt') || '' : '';
  }

  function juntar(gatilho) {
    var caixa = gatilho.closest(GALLERY);
    var nos = caixa ? caixa.querySelectorAll(TRIGGER) : [gatilho];
    var lista = [];
    var pos = 0;
    for (var i = 0; i < nos.length; i++) {
      var url = endereco(nos[i]);
      if (!url) continue;
      if (nos[i] === gatilho) pos = lista.length;
      lista.push({ src: url, alt: descricao(nos[i]) });
    }
    if (!lista.length) {
      var solto = endereco(gatilho);
      if (solto) lista.push({ src: solto, alt: descricao(gatilho) });
    }
    return { lista: lista, pos: pos };
  }

  /* ------------------------------------------------------------ exibição */

  function mostrar(i) {
    if (!fotos.length) return;
    atual = (i % fotos.length + fotos.length) % fotos.length;
    var item = fotos[atual];
    var varias = fotos.length > 1;

    raiz.classList.add('is-loading');
    foto.alt = item.alt || '';
    foto.src = item.src;
    if (foto.complete) assentar();

    contador.textContent = (atual + 1) + '/' + fotos.length;
    contador.hidden = !varias;
    btAnterior.hidden = !varias;
    btProxima.hidden = !varias;

    if (varias) {
      // adianta a vizinha para a troca sair sem espera
      var proxima = new Image();
      proxima.src = fotos[(atual + 1) % fotos.length].src;
    }
  }

  function travar() {
    var corpo = document.body;
    var barra = window.innerWidth - document.documentElement.clientWidth;
    travaScroll = { overflow: corpo.style.overflow, padding: corpo.style.paddingRight };
    corpo.style.overflow = 'hidden';
    if (barra > 0) {
      var atualPad = parseFloat(window.getComputedStyle(corpo).paddingRight) || 0;
      corpo.style.paddingRight = (atualPad + barra) + 'px';
    }
  }

  function destravar() {
    if (!travaScroll) return;
    document.body.style.overflow = travaScroll.overflow;
    document.body.style.paddingRight = travaScroll.padding;
    travaScroll = null;
  }

  function abrir(gatilho) {
    var grupo = juntar(gatilho);
    if (!grupo.lista.length) return;

    montar();

    var cor = gatilho.getAttribute('data-dl-accent');
    raiz.style.setProperty('--dl-lb-cor', cor && COR_OK.test(cor) ? cor : '#3E1D28');

    fotos = grupo.lista;
    origem = gatilho;
    raiz.hidden = false;
    travar();
    mostrar(grupo.pos);
    btFechar.focus();
  }

  function fechar() {
    if (!raiz || raiz.hidden) return;
    raiz.hidden = true;
    foto.removeAttribute('src');
    destravar();
    fotos = [];
    if (origem && document.contains(origem) && typeof origem.focus === 'function') {
      origem.focus();
    }
    origem = null;
  }

  function aberto() {
    return !!raiz && !raiz.hidden;
  }

  /* ------------------------------------------------------------- eventos */

  document.addEventListener('click', function (ev) {
    if (ev.button && ev.button !== 0) return;
    var alvo = ev.target && ev.target.nodeType === 1 ? ev.target : null;
    if (!alvo || !alvo.closest) return;
    var gatilho = alvo.closest(TRIGGER);
    if (!gatilho) return;
    ev.preventDefault();
    abrir(gatilho);
  });

  document.addEventListener('keydown', function (ev) {
    if (!aberto()) return;

    if (ev.key === 'Escape' || ev.key === 'Esc') {
      ev.preventDefault();
      fechar();
      return;
    }
    if (fotos.length > 1 && (ev.key === 'ArrowLeft' || ev.key === 'ArrowRight')) {
      ev.preventDefault();
      mostrar(atual + (ev.key === 'ArrowLeft' ? -1 : 1));
      return;
    }
    if (ev.key === 'Tab') {
      // mantém o foco dentro do visualizador enquanto ele estiver aberto
      var focaveis = [];
      var botoes = raiz.querySelectorAll('.dl-lb__bt');
      for (var i = 0; i < botoes.length; i++) {
        if (!botoes[i].hidden) focaveis.push(botoes[i]);
      }
      if (!focaveis.length) return;
      var primeiro = focaveis[0];
      var ultimo = focaveis[focaveis.length - 1];
      var foco = document.activeElement;
      if (ev.shiftKey && (foco === primeiro || !raiz.contains(foco))) {
        ev.preventDefault();
        ultimo.focus();
      } else if (!ev.shiftKey && (foco === ultimo || !raiz.contains(foco))) {
        ev.preventDefault();
        primeiro.focus();
      }
    }
  });

  // sai do visualizador se a navegação mudar de página sem recarregar
  window.addEventListener('pagehide', fechar);
})();
